import { UserBookmarkCountBy } from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-by";
import UserBookmarkCountSortOption from "models/enumerations/sorting/user-bookmarks/user-bookmark-count-sort-option";
import UserCollectionShareType from "models/enumerations/user-collection-share-type";
import UserBookmarkCountRecord from "models/view-models/user-bookmark-count-record";
import ServiceFactory from "utilities/services/service-factory";

// ---------------------------------------------------------------------------------------------
// #region Interfaces
// ---------------------------------------------------------------------------------------------
export interface UserBookmarkCountListQueryParams {
    countBy?: UserBookmarkCountBy;
    collectionShareType?: UserCollectionShareType;
    sortOption?: UserBookmarkCountSortOption;
    bookmarksCreatedByMe?: boolean;
    searchText?: string;
} // Filters, sorting eventually go here

// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "userbookmarks/count";
const resourceType = UserBookmarkCountRecord;

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------
const key = "userbookmarks";

const UserBookmarkCountService = {
    key,
    list: ServiceFactory.list<
        UserBookmarkCountRecord,
        UserBookmarkCountListQueryParams
    >(resourceType, baseEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default UserBookmarkCountService;

// #region Exports
